import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import useQueryString from "@starter/Framework/Common/Hooks/useQueryString";
import { useSelector } from "react-redux";

const useQuote = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { quoteId } = useQueryString();

    return useSelector((state: ApplicationState) => {
        if (options?.quote) {
            return options.quote;
        }

        if (quoteId) {
            return getQuoteState(state, quoteId).value;
        }
    });
};

export default useQuote;
